import React from "react";
import { Button } from "@shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@shared/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { SelectUser } from "@features/users/SelectUser";
import { useUpdateUser } from "@features/users/useUsers";
import { toast } from "sonner";
import { Headphones, Edit3 } from "lucide-react";

export default function AssignSupport({ clientUser }) {
  const { t } = useTranslation();
  const { updateUser, isLoading } = useUpdateUser();
  const [open, setOpen] = React.useState(false);
  const [supportId, setSupportId] = React.useState(
    clientUser?.assignedSupport?._id || ""
  );

  React.useEffect(() => {
    setSupportId(clientUser?.assignedSupport?._id || "");
  }, [clientUser]);

  const handleSave = () => {
    if (!clientUser) return;
    updateUser(
      { id: clientUser._id, values: { assignedSupport: supportId } },
      {
        onSuccess: () => {
          toast.success(t("users.supportAssigned"));
          setOpen(false);
        },
        onError: (error) => {
          toast.error(error?.response?.data?.message || t("messages.error"));
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Edit3 className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Headphones className="h-5 w-5" />
            {t("users.assignSupport")}
          </DialogTitle>
          <DialogDescription>
            {t("users.assignSupportDescription")}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <SelectUser
            role="clientSupport"
            onSelectUser={(id) => setSupportId(id)}
            user={supportId}
            showAllOption={true}
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setOpen(false)}
            disabled={isLoading}
          >
            {t("main.cancel")}
          </Button>
          <Button onClick={handleSave} disabled={isLoading}>
            {isLoading ? t("main.saving") : t("main.save")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
